import axios from 'axios';
import {
  API_URL,
  SHIP_BUILDERS,
  SHOW_SHIP_BUILDER,
  CREATE_SHIP_BUILDER,
  UPDATE_SHIP_BUILDER,
  DELETE_SHIP_BUILDER,
} from './ConstantService';

export const ShipBuilderService = {
  getAllShipBuilders(params = {}) {
    return axios.get(SHIP_BUILDERS, { params });
  },

  show(id) {
    return axios.get(SHOW_SHIP_BUILDER.replace('{id}', id));
  },

  create(data) {
    return axios.post(CREATE_SHIP_BUILDER, data);
  },

  update(id, data) {
    return axios.patch(UPDATE_SHIP_BUILDER.replace('{id}', id), data);
  },

  deleteWithPassword(id, password) {
    return axios.post(DELETE_SHIP_BUILDER.replace('{id}', id), { password });
  },
};
